import React from "react"
import "./sentry.ts"
import ReactDOM from "react-dom/client"
import { QueryClientProvider } from "@tanstack/react-query"
// import { ReactQueryDevtools } from "@tanstack/react-query-devtools"
import { App } from "./App.tsx"
import { AppProvider } from "components/providers/App.provider.tsx"
import { AuthProvider } from "components/providers/Auth.provider.tsx"
import { BrowserRouter } from "react-router-dom"
import { queryClient } from "api/queryClient"

export { queryClient }

ReactDOM.createRoot(document.getElementById("root")!).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			{/* <ReactQueryDevtools initialIsOpen={false} /> */}
			<AppProvider>
				<BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
					<AuthProvider>
						<App />
					</AuthProvider>
				</BrowserRouter>
			</AppProvider>
		</QueryClientProvider>
	</React.StrictMode>,
)
